<mat-card appearance="outlined" class="population-card">
  <mat-card-content class="population-card__content">
    @if (editMode) {
      <div class="name-description-container">
        <mat-form-field class="population-field population-field--name">
          <mat-label>Name</mat-label>
          <input matInput placeholder="Name" type="text" [value]="pop.name" [(ngModel)]="pop.name" />
        </mat-form-field>
        <mat-form-field class="population-field population-field--description">
          <mat-label>Description</mat-label>
          <input matInput placeholder="Description" type="text" [value]="pop.description" [(ngModel)]="pop.description" />
        </mat-form-field>
      </div>
      <div class="fake-mat-quill">
        <span style="top: 0px"> Optional message to display in the next steps for this population </span>
        <quill-editor [appQuillA11y]="'Next steps editor for population ' + (pop.name || 'entry')" [modules]="modules" placeholder="(Optional) Next Steps text..." theme="snow" bounds="self" [(ngModel)]="pop.nextStep"></quill-editor>
      </div>
    }
    @if (pop.nextStep && !editMode) {
      <div class="population-next-steps">
        <p><b>Message to display in the next steps for this population</b></p>
        <span [innerHTML]="pop.nextStep"></span>
      </div>
    }
    <!-- Population Header for Multiple Blocks -->
    @if (pop.blocks.length > 1) {
      <div>
        @if (!editMode) {
          <div>
            {{ pop.blocks.length }} blocks joined by <small>{{ pop.groupOperatorAnd === true ? "AND" : "OR" }}</small> condition
          </div>
        }
        @if (editMode) {
          <div>
            <h3>Multiple Block Logic</h3>
            <mat-label id="multi-block-join-condition">Select logic for {{ pop.blocks.length }} blocks: </mat-label>
            <mat-radio-group [(ngModel)]="pop.groupOperatorAnd" role="radiogroup" aria-labelledby="multi-block-join-condition" class="block-choices">
              <mat-radio-button aria-label="All Blocks must be true" [value]="true" class="radio-option">All Blocks must be true</mat-radio-button>
              <mat-radio-button aria-label="Any Block may be true" [value]="false" class="radio-option">Any Block may be true</mat-radio-button>
            </mat-radio-group>
          </div>
        }
      </div>
    }

    <!-- Display a Block -->
    @for (block of pop.blocks; track block; let blockIndex = $index) {
      <div>
        <!-- Block Header for Multiple Conditions -->
        @if (block.conditions.length > 1 || (pop.blocks.length > 1 && block.conditions.length > 0)) {
          <div style="margin-bottom: 1rem">
            @if (!editMode) {
              <div>Block Condition: {{ block.blockOperatorAnd === true ? "All have to" : "Any can" }} be true</div>
            }
            @if (editMode) {
              <div>
                <span class="block-title">
                  <h3>Block {{ blockIndex + 1 }}</h3>
                  <button mat-button style="margin-left: 2rem" (click)="addBlock(pop)">add block</button>
                  @if (pop.blocks.length > 1) {
                    <button mat-button (click)="pop.blocks.splice(blockIndex, 1)">remove block</button>
                  }
                </span>
                <label id="block-join-condition">Select condition logic for block {{ blockIndex + 1 }}: </label>
                <mat-radio-group [(ngModel)]="block.blockOperatorAnd" role="radiogroup" aria-labelledby="block-join-condition" class="block-choices">
                  <mat-radio-button aria-label="All Blocks must be true" [value]="true" class="radio-option">All Conditions must be true</mat-radio-button>
                  <mat-radio-button aria-label="Any Block may be true" [value]="false" class="radio-option">Any Condition may be true</mat-radio-button>
                </mat-radio-group>
              </div>
            }
          </div>
        }
        <!-- Block Contents -->
        <div [ngClass]="{ 'pop-block': pop.blocks.length > 1 }" class="population-block-scroll" appKeyboardScrollable>
          <table class="table" style="width: auto">
            <thead>
              <tr>
                <th scope="col" id="population-question-header">Question/Input</th>
                <th scope="col" id="population-operator-header">Operator</th>
                <th scope="col" id="population-assertion-header">Assertion</th>
                @if (editMode) {
                  <th scope="col" id="population-actions-header">Actions</th>
                }
              </tr>
            </thead>
            @for (cond of block.conditions; track cond; let condIndex = $index) {
              <!-- Display a Condition -->
              @if (!editMode) {
                <tr>
                  <th scope="row" [id]="getConditionRowHeaderId(blockIndex, condIndex)">
                    @if (cond.type === "Question") {
                      <div>
                        {{ cond.question?.label || cond.keyId }}
                      </div>
                    }
                    @if (cond.type === "Formula") {
                      <div>
                        Formula ({{ cond.formulaId }}): <strong>{{ cond.formula?.name }}</strong> <br />
                        <small>{{ cond.formula?.description }}</small>
                      </div>
                    }
                    @if (cond.type === "Calculation") {
                      <div>
                        {{ getSelectorName(cond.keyId) }}
                      </div>
                    }
                  </th>
                  <td>
                    {{ conditionMap[cond.operator] }}
                  </td>
                  <td>
                    @if (cond.question?.format === "Code") {
                      <div>
                        <select class="custom-select" multiple disabled [ngModel]="cond.values" [attr.aria-labelledby]="getConditionControlLabelIds('assertion', blockIndex, condIndex)">
                          @for (choice of cond.question.choices; track choice) {
                            <option [value]="choice.value">{{ choice.label }}</option>
                          }
                        </select>
                      </div>
                    }
                    @if (cond.operator === 6) {
                      <div>{{ cond.value }} and {{ cond.value2 }}</div>
                    }
                    @if (cond.operator >= 0 && cond.operator <= 5 && cond.question?.format !== "Code") {
                      <div>
                        {{ cond.value }}
                      </div>
                    }
                  </td>
                </tr>
              } @else {
                <!-- Edit a Condition -->
                <tr [attr.id]="getConditionRowId(blockIndex, condIndex)">
                  <!-- Question/Calculation/Formula Selector -->
                  <th scope="row" [id]="getConditionRowHeaderId(blockIndex, condIndex)">
                    <div class="condition-question">
                      <input-selector #inputSelector [key]="cond" [caller]="'Population'"></input-selector>
                    </div>
                  </th>
                  <!-- Select condition operator -->
                  <td>
                    <mat-form-field style="width: 8rem">
                      <mat-label>Operator</mat-label>
                      @if (cond.question?.format !== "Code" || cond.type !== "Question") {
                        <mat-select [(value)]="cond.operator" placeholder="Operator" [attr.aria-labelledby]="getConditionControlLabelIds('operator', blockIndex, condIndex)">
                          @for (operator of conditionMap; track operator; let i = $index) {
                            <mat-option [value]="i">{{ operator }} </mat-option>
                          }
                        </mat-select>
                      }
                      @if (cond.question?.format === "Code" && cond.type === "Question") {
                        <mat-select [(value)]="cond.operator" placeholder="Operator" [attr.aria-labelledby]="getConditionControlLabelIds('operator', blockIndex, condIndex)">
                          <mat-option [value]="0">{{ conditionMap[0] }}</mat-option>
                          <mat-option [value]="5">{{ conditionMap[5] }}</mat-option>
                        </mat-select>
                      }
                      @if (cond.operator === 6) {
                        <mat-hint>(inclusive)</mat-hint>
                      }
                    </mat-form-field>
                  </td>
                  <!-- Enter value, values, or multi-select choices -->
                  <td>
                    <!-- Show question choices if type is a question with a format of code -->
                    @if (cond.question?.format === "Code" && cond.type === "Question") {
                      <div>
                        <select class="custom-select" multiple [(ngModel)]="cond.values" [attr.aria-labelledby]="getConditionControlLabelIds('assertion', blockIndex, condIndex)">
                          @for (choice of cond.question.choices; track choice) {
                            <option [value]="choice.value">{{ choice.label }}</option>
                          }
                        </select>
                      </div>
                    }
                    <!-- Show yes/no choices if type is a question with a format of Boolean -->
                    @if (cond.question?.format === "Boolean" && cond.type === "Question") {
                      <div>
                        <select class="custom-select" [(ngModel)]="cond.value" (change)="cond.values = null" [attr.aria-labelledby]="getConditionControlLabelIds('assertion', blockIndex, condIndex)">
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      </div>
                    }
                    <!-- Show two values if operator is between -->
                    @if (cond.operator === 6) {
                      <div>
                        <mat-form-field [hideRequiredMarker]="true" class="form-field">
                          <mat-label>From Value</mat-label>
                          <input matInput placeholder="From Value" type="number" [value]="cond.value" [(ngModel)]="cond.value" />
                          <mat-error>Please enter a value</mat-error>
                        </mat-form-field>
                        and
                        <mat-form-field [hideRequiredMarker]="true" class="form-field">
                          <mat-label>To Value</mat-label>
                          <input matInput placeholder="To Value" type="number" [value]="cond.value2" [(ngModel)]="cond.value2" />
                          <mat-error>Please enter a value</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    <!-- Show a single value if the operator is not between and the question is not a code or boolean-->
                    @if (cond.operator !== 6 && ((cond.question?.format !== "Code" && cond.question?.format !== "Boolean") || cond.type !== "Question")) {
                      <div>
                        <mat-form-field [hideRequiredMarker]="true" class="form-field">
                          <mat-label>Value</mat-label>
                          <input matInput placeholder="Value" type="number" [value]="cond.value" [(ngModel)]="cond.value" />
                          <mat-error>Please enter a value</mat-error>
                        </mat-form-field>
                      </div>
                    }
                  </td>
                  <td>
                    <div style="display: flex; align-items: center; min-height: 3.5rem">
                      <button mat-button color="warn" (click)="removeCondition(pop, blockIndex, condIndex)" [attr.aria-labelledby]="getRemoveConditionLabelId(blockIndex, condIndex) + ' ' + getConditionRowId(blockIndex, condIndex)">
                        <span [attr.id]="getRemoveConditionLabelId(blockIndex, condIndex)">remove condition</span>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            }
            <tr>
              <td>
                @if (editMode) {
                  <div style="display: flex; align-items: center; min-height: 3.5rem">
                    <button mat-button (click)="addCondition(block)">add condition</button>
                  </div>
                }
              </td>
              <td></td>
              <td></td>
              @if (editMode) {
                <td></td>
              }
            </tr>
          </table>
        </div>
      </div>
    }
  </mat-card-content>
  @if (editMode) {
    <div class="population-save-bar">
      <button mat-button type="button" (click)="cancelEdit.emit()">Cancel</button>
      <button mat-flat-button color="accent" (click)="savePopulation.emit()">Save</button>
    </div>
  } @else {
    <div class="population-save-bar">
      <button mat-flat-button color="primary" (click)="edit.emit()">Edit</button>
      <button mat-stroked-button color="warn" (click)="delete.emit()" [disabled]="isNew">Delete</button>
    </div>
  }
</mat-card>
